import type { LauncherTeaserPageOverride } from '../hooks/useFetchWidgetConfig';

export function resolveLauncherTeaserMessage(
  pageUrl: string,
  defaultMessage: string,
  overrides: LauncherTeaserPageOverride[] = [],
): string {
  const match = overrides.find((o) => o.pageUrl === pageUrl);
  return match?.message ?? defaultMessage;
}
